import "core-js/modules/es.string.replace.js";
import React from 'react';
import ArrowBackIcon from '@pixel/assets/icons/ArrowBack';
import ArrowForwardIcon from '@pixel/assets/icons/ArrowForward';
import FirstPageIcon from '@pixel/assets/icons/FirstPage';
import LastPageIcon from '@pixel/assets/icons/LastPage';
import IconButton from '../IconButton';
import { styled } from '../styles';
import Typography from '../Typography';
const Container = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '8px'
}));
export function ListPaginator(_ref) {
  let {
    results,
    labelFirstToLastOfTotal = '${first} to ${last} of ${total}',
    labelTo = "-",
    //i18n agnostic version of "to"
    labelOf = ":",
    //i18n agnostic version of "of"
    onChange = (e, page) => {
      console.warn("implement ListBase onPageChanged event (e, page)");
    } //default empty function
  } = _ref;
  const {
    pagingContext,
    totalCount
  } = results;
  if (!pagingContext) {
    return null;
  }
  const {
    perPage,
    page: currentPage,
    first: firstRecord,
    last: lastRecord,
    results_count: pagingContextResultsCount
  } = pagingContext;
  const totalRecords = typeof totalCount === "number" ? totalCount : pagingContextResultsCount || 0;
  const hasPaging = totalRecords > perPage;
  const lastPage = Math.ceil(totalRecords / perPage);
  let backBtnDisabled = true;
  let forwardBtnDisabled = true;
  let displayFirstLastControls = false;
  let label = '';
  if (pagingContext.isCursor) {
    // @todo: Cursor-based pagination
  } else {
    label = labelFirstToLastOfTotal.replace('${first}', firstRecord).replace('${to}', labelTo).replace('${last}', lastRecord).replace('${of}', labelOf).replace('${total}', totalRecords);
    if (hasPaging) {
      if (currentPage > 1) {
        backBtnDisabled = false;
      }
      if (currentPage < lastPage) {
        forwardBtnDisabled = false;
      }
    }
    displayFirstLastControls = !pagingContext.hideFirstLastActions && lastPage > 2;
  }
  const displayControls = !(backBtnDisabled && forwardBtnDisabled);
  return /*#__PURE__*/React.createElement(Container, null, displayControls && /*#__PURE__*/React.createElement(React.Fragment, null, displayFirstLastControls && /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "First Page",
    size: "small",
    onClick: e => onChange(e, 1),
    disabled: backBtnDisabled,
    sx: {
      mr: 2
    }
  }, /*#__PURE__*/React.createElement(FirstPageIcon, {
    fontSize: "inherit"
  })), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Previous",
    size: "small",
    onClick: e => onChange(e, currentPage - 1),
    disabled: backBtnDisabled,
    sx: {
      mr: 2
    }
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, {
    fontSize: "inherit"
  })), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Next",
    size: "small",
    onClick: e => onChange(e, currentPage + 1),
    disabled: forwardBtnDisabled,
    sx: {
      mr: 2
    }
  }, /*#__PURE__*/React.createElement(ArrowForwardIcon, {
    fontSize: "inherit"
  })), displayFirstLastControls && /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Last Page",
    size: "small",
    onClick: e => onChange(e, lastPage),
    disabled: forwardBtnDisabled,
    sx: {
      mr: 2
    }
  }, /*#__PURE__*/React.createElement(LastPageIcon, {
    fontSize: "inherit"
  }))), /*#__PURE__*/React.createElement(Typography, {
    variant: "overline"
  }, label));
}
export default ListPaginator;